export const ORDERS = "ORDERS";
export const PENDING = "PENDING";
export const CANCEL = "CANCEL";
export const ONTRANSIT = "ONTRANSIT";
